export default __webpack_public_path__ + "static/media/error-states.d04e8add.png";